import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Markdown from '../components/Markdown.jsx';
import { CATEGORY_LABELS } from '../content/site.js';

export default function Post() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState('loading');   // loading | ready | missing

  useEffect(() => {
    setState('loading');
    fetch(`/api/posts/${encodeURIComponent(slug)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('missing'))))
      .then((d) => { setData(d); setState('ready'); })
      .catch(() => setState('missing'));
  }, [slug]);

  useEffect(() => {
    if (data?.post) document.title = `${data.post.title} | Ennoveda`;
    return () => { document.title = 'Ennoveda Inc. — Brilliance at the Basics'; };
  }, [data]);

  if (state === 'loading') {
    return <section className="section"><div className="shell"><p className="dim mono">Loading…</p></div></section>;
  }

  if (state === 'missing') {
    return (
      <section className="section">
        <div className="shell">
          <h1>Not found</h1>
          <p className="lede" style={{ marginTop: '1rem' }}>
            That issue isn't here. It may have been unpublished.
          </p>
          <p style={{ marginTop: '1.6rem' }}>
            <Link className="btn btn-ghost" to="/blog">Back to the Cyber Brief</Link>
          </p>
        </div>
      </section>
    );
  }

  const { post, newer, older } = data;

  return (
    <article>
      <section className="page-head">
        <div className="shell" style={{ maxWidth: '48rem' }}>
          <p className="eyebrow">{CATEGORY_LABELS[post.category] || post.category}</p>
          <h1 className="post-title">{post.title}</h1>
          <p className="faint mono" style={{ marginTop: '1.2rem', fontSize: '0.8rem' }}>
            {post.published_date}
            {post.author ? ` · ${post.author}` : ''}
            {post.read_time_minutes ? ` · ${post.read_time_minutes} min read` : ''}
          </p>
        </div>
      </section>

      {post.cover_image_url && (
        <div className="shell" style={{ maxWidth: '48rem' }}>
          <img className="post-hero" src={post.cover_image_url} alt="" />
        </div>
      )}

      <section className="section" style={{ paddingTop: '2.5rem' }}>
        <div className="shell" style={{ maxWidth: '48rem' }}>
          <Markdown text={post.content} />

          <nav className="post-nav">
            {newer ? (
              <Link to={`/blog/${newer.slug}`}>
                <span className="eyebrow eyebrow-grey">Newer</span>
                <span>{newer.title}</span>
              </Link>
            ) : <span />}
            {older ? (
              <Link to={`/blog/${older.slug}`} className="right">
                <span className="eyebrow eyebrow-grey">Older</span>
                <span>{older.title}</span>
              </Link>
            ) : <span />}
          </nav>
        </div>
      </section>
    </article>
  );
}
